var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"itemBoxComparison"},[_c('div',{staticClass:"top",staticStyle:{"width":"100%","height":"100%"}},[_c('TitlesImg',{attrs:{"type":_vm.record.titleImgType}}),_c('div',{staticClass:"titlePosition",staticStyle:{"margin-left":"2em"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.record.title))])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }